import Papa from 'papaparse';
import { saveAs } from 'file-saver';
import { Activity } from '../types';
import { format } from 'date-fns';

/**
 * Exports activity log to CSV file
 * @param activities - Array of activities to export
 * @param memberName - Name of the team member
 */
export function exportActivityLogToCsv(activities: Activity[], memberName: string): void {
  if (activities.length === 0) {
    console.warn('No activities to export');
    return;
  }

  // Convert activities to CSV data
  const csvData = activities.map((activity) => {
    const date = new Date(activity.timestamp);
    const formattedDate = format(date, 'MMM dd, yyyy');
    const formattedTime = format(date, 'HH:mm');
    
    return {
      'Date': formattedDate,
      'Time': formattedTime,
      'Activity Type': activity.title,
      'Description': activity.description,
      'Course Name': activity.metadata?.courseName || '',
      'Badge Name': activity.metadata?.badgeName || '',
      'Certification Name': activity.metadata?.certificationName || '',
      'Duration (minutes)': activity.metadata?.duration?.toString() || '',
    };
  });

  // Generate CSV string using PapaParse
  const csv = Papa.unparse(csvData, {
    header: true,
    delimiter: ',',
    newline: '\n',
  });

  // Add BOM for UTF-8 to ensure Excel opens it correctly
  const BOM = '\uFEFF';
  const csvWithBOM = BOM + csv;

  // Generate filename with timestamp
  const timestamp = format(new Date(), 'yyyy-MM-dd_HH-mm-ss');
  const sanitizeFilename = (name: string): string => {
    return name.replace(/[^a-z0-9\s-]/gi, '').replace(/\s+/g, '-').toLowerCase();
  };
  const filename = `activity-log-${sanitizeFilename(memberName)}-${timestamp}`.replace(/[<>:"/\\|?*]/g, '');

  // Create blob and save using file-saver
  try {
    const blob = new Blob([csvWithBOM], { 
      type: 'text/csv;charset=utf-8;' 
    });
    
    saveAs(blob, `${filename}.csv`);
  } catch (error) {
    console.error('Error exporting activity log:', error);
    // alert('Failed to export activity log. Please check your browser settings or try again.');
  }
}

